import { getUserLocale } from 'get-user-locale';

import * as en from './en.json';

const getTranslations = (lang: string) => {
  switch (lang) {
    case 'en': return en;
    // French translations are not ready yet
    // case 'fr': return fr;
    default:
      return en;
  }
};

export function getUserLanguage() {
  let language: string = 'en';
  const locale: string | undefined = getUserLocale();
  if (locale) {
    try {
      language = locale.split('-')[0];
    // tslint:disable-next-line:no-empty
    } catch (e) {}
  }
  return language;
}

export const currentLang = getUserLanguage();

export default getTranslations(currentLang);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/locales/index.ts